__turbopack_context__.v({
  "className": "lora_3cace1af-module__bn_LTq__className",
});
